import { render, staticRenderFns } from "./BlockSingleProperty.vue?vue&type=template&id=1db1063a&scoped=true&"
import script from "./BlockSingleProperty.vue?vue&type=script&lang=js&"
export * from "./BlockSingleProperty.vue?vue&type=script&lang=js&"
import style0 from "./BlockSingleProperty.vue?vue&type=style&index=0&id=1db1063a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db1063a",
  null
  
)

export default component.exports